import { Component, ViewChild } from '@angular/core';

import {
    AlertController, LoadingController, ModalController, NavParams, ToastController,
    ViewController
} from 'ionic-angular';

import { ConferenceData } from '../../../providers/conference-data';
import { MissionsData } from '../../../providers/missions-data';
import { UiData } from '../../../providers/ui-data';
import {UserData} from "../../../providers/user-data";

import { JobSelectForm } from '../../utils/job-select/job-select';
import { DocumentSelectForm } from '../../utils/document-select/document-select'
import { Geolocation } from '@ionic-native/geolocation';
import {LocationSelectForm} from "../../utils/location-select/location-select";
import {FormGroup, FormBuilder, FormControl, Validators} from '@angular/forms';
import {CvAddForm} from "../../account/cv/form/cvform";
import {Observable} from "rxjs/Observable";

import {SignaturePad} from 'angular2-signaturepad/signature-pad';
import { Signpad } from '../../utils/signpad/signpad';
import {UploadService} from "../../../services/upload-service";
import {Upload} from "../../../services/upload";
import * as firebase from "firebase";
import {RibSelect} from "../../utils/rib-select/rib-select";

declare var google: any;


@Component({
    selector: 'page-missions-sign',
    templateUrl: 'missions-sign.html'
})
export class MissionsSignPage {

    @ViewChild(SignaturePad) public signaturePad : SignaturePad;

    mission: any;
    segment: any;
    user: any;

    postulateData: any;
    postulateForm : FormGroup;

    requirementsData: any;
    requirementsForm : FormGroup;

    submitAttempt: boolean = false;
    steps:any = 3;
    step:any = 1;

    formationsRef: any;
    experiencesRef: any;
    certificatesRef: any;
    languagesRef: any;
    countryList: any;

    signature:any = false;
    signed: boolean = false;
    signedDate: any;

    loading: any = false;
    currently_loading: any = false;

    uploadSignatureTask:any;

    cguAgreed: boolean = false;
    cguError: boolean = false;

    public signaturePadOptions : Object = {
        'minWidth': 2,
        'canvasWidth': 340,
        'canvasHeight': 200

    };
    public signatureImage : string;

    constructor(
        public uiData: UiData,
        public missionsData: MissionsData,
        public navParams: NavParams,
        public userData: UserData,
        public viewCtrl: ViewController,
        public formBuilder: FormBuilder,
        public alertCtrl: AlertController,
        public modalCtrl: ModalController,
        private geolocation: Geolocation,
        public loadingCtrl: LoadingController,
        public toastCtrl: ToastController,
        public uploadService: UploadService

    ) {
        this.postulateForm = this.formBuilder.group({
            secu: [null, [Validators.required, this.secuValidator.bind(this) ]],

            adr1: ['', [Validators.required,Validators.minLength(5)]],
            cp: ['', [Validators.required,Validators.pattern(this.uiData.getZipcodePattern()),Validators.minLength(4)]],
            ville: ['', [Validators.required,Validators.minLength(2)]],
            pays: [null, Validators.required],
            //vitale: [null, [Validators.required ]],
            last_visit: ['', [Validators.required]],
            rib_info: ['', [Validators.required]],
            identity: [null, [Validators.required ]],
            domicile: [null, [Validators.required ]],
        });
    }
    addRibInfo()
    {
        var that = this;
        let documentSelectModal = this.modalCtrl.create(RibSelect, { 'rib':that.postulateData.rib_info });
        documentSelectModal.onDidDismiss(data => {
            if(data && data.success){
                that.postulateData.rib_info = {'iban':data.iban};
            }
        });
        documentSelectModal.present();
    }
    changeRibInfo()
    {
        this.addRibInfo();
    }
    secuValidator(control: FormControl): {[s: string]: boolean} {
        if (control.value && control.value.length < 15) {
            return {invalidSecu: true};
        }
        if (control.value && control.value.length > 15) {
            return {invalidSecu: true};
        }
    }
    setLoading(state,msg=""){
        if(msg == "")msg = 'Chargement des missions ...';
        if(state)
        {
            this.currently_loading = true;
            this.loading = this.loadingCtrl.create({
                content: msg
            });
            this.loading.present();
        }
        else if(this.loading){
            this.currently_loading = false;
            this.loading.dismiss();
        }
    }
    geoLocate()
    {
        var that = this;
        this.setLoading(true,'Géolocalisation en cours ...');
        this.geolocation.getCurrentPosition().then((resp) => {
            var geocoder = new google.maps.Geocoder;
            var latlng = {lat: resp.coords.latitude, lng: resp.coords.longitude};
            var that = this;
            geocoder.geocode({'location': latlng}, function(results, status) {

                if (status === 'OK') {
                    if (results[0]) {
                        for(let i=0;i<results[0].address_components.length;i++)
                        {
                            let component = results[0].address_components[i];
                            if(component.types.includes("route"))
                            {
                                that.postulateData.adr1 = component.long_name;
                            }
                            if(component.types.includes("locality"))
                            {
                                that.postulateData.ville = component.long_name;
                            }
                            if(component.types.includes("postal_code"))
                            {
                                that.postulateData.cp = component.long_name;
                            }
                            if(component.types.includes("country"))
                            {
                                that.postulateData.pays = component.short_name;
                            }
                        }
                    } else {
                    }
                } else {
                }
                that.setLoading(false);
            });
        }).catch((error) => {
            const toast = this.toastCtrl.create({
                message: 'La géolocalisation a échoué. ' +
                'Il est possible que vous ayez refusé d\'être géolocalisé ou que les paramètres de votre appareil ne le permette pas.' +
                'N\'hésitez pas à choisir le mode de recherche par adresse.',
                showCloseButton: true,
                cssClass: 'danger',
                closeButtonText: 'Ok',
                dismissOnPageChange: true,
                duration:10000
            });
            toast.present();
            //this.searchFilters.location.mode = 'address';
            this.setLoading(false);
        });
    }
    ionViewDidLoad() {
        var that = this;
        this.segment = "step1";
        this.step = 1;

        this.postulateData = {
            secu: '',

            adr1 : '',
            adr2 : '',
            cp : '',
            ville : '',
            pays : 'FR',
            last_visit: '',

            vitale: '',
            identity: '',
            domicile: '',
            rib: '',
        };

        /*this.missionsData.load().subscribe((data: any) => {
            for(let i=0;i<data.length;i++){
                if(data[i].id === this.navParams.data.missionId)
                {
                    this.mission = data[i];
                }
            }
        });*/
        this.countryList = this.uiData.countryList();
        this.userData.load().subscribe(data => {
            that.user = data;
            var registry=that.user['missionCandidates'];
            for(let i=0;i<Object.keys(registry).length;i++){
                var candidate = registry[Object.keys(registry)[i]];
                if(candidate.mission.id === this.navParams.data.missionId)
                {
                    this.mission = candidate.mission;
                }
            }
            if(that.user.identity)
            {
                if(that.user.identity.secu)    this.postulateData.secu = that.user.identity.secu;
                if(that.user.identity.last_visit)    this.postulateData.last_visit = that.user.identity.last_visit;
            }
            if(that.postulateData.last_visit && that.postulateData.last_visit=="2000-01-01")
            {
                that.postulateData.no_visit = true;
            }
            if(that.user.address)
            {
                if(that.user.address.adr1)    this.postulateData.adr1 = that.user.address.adr1;
                if(that.user.address.adr2)    this.postulateData.adr2 = that.user.address.adr2;
                if(that.user.address.cp)    this.postulateData.cp = that.user.address.cp;
                if(that.user.address.ville)    this.postulateData.ville = that.user.address.ville;
                if(that.user.address.pays)    this.postulateData.pays = that.user.address.pays;
            }
            if(that.user.documents)
            {
                if(that.user.documents.vitale)
                    this.postulateData.vitale = that.user.documents.vitale.url;
                if(that.user.documents.identity)
                    this.postulateData.identity = that.user.documents.identity.url;
                if(that.user.documents.domicile)
                    this.postulateData.domicile = that.user.documents.domicile.url;
                if(that.user.documents.rib)
                    this.postulateData.rib = that.user.documents.rib.url;
                if(that.user.documents.rib_info)
                    this.postulateData.rib_info = that.user.documents.rib_info;
            }

        });
    }
    addVitale()
    {
        this.chooseDocument('vitale') ;
    }
    addDomicile()
    {
        this.chooseDocument('domicile') ;
    }
    addIdentity()
    {
        this.chooseDocument('identity') ;
    }
    addRib()
    {
        this.chooseDocument('rib') ;
    }
    chooseDocument(mode)
    {
        let documentSelectModal = this.modalCtrl.create(DocumentSelectForm, { document_type: mode });
        documentSelectModal.onDidDismiss(data => {
            if(data && data.document_type)
            {
                this.postulateData[data.document_type] = data.url;
            }
            else
            {

            }
        });
        documentSelectModal.present();
    }
    signpad()
    {
        let documentSelectModal = this.modalCtrl.create(Signpad);
        documentSelectModal.onDidDismiss(data => {
            if(data)
            {
                this.signature = data;
                this.signed = true;
                this.signedDate = Date.now();
            }
            else
            {
                this.signature = false;
                this.signed = false;
            }
        });
        documentSelectModal.present();
    }
    savePostulate() {

        this.submitAttempt=true;
        var that = this;

        if(that.postulateData.no_visit)that.postulateData.last_visit="2000-01-01";

        if(this.postulateForm.valid)
        {
            let prompt = this.alertCtrl.create({
                title: 'Confirmation des informations',
                message: that.uiData.getDataValidationWarning(),
                buttons: [
                    {
                        text: 'Oui',
                        handler: data => {
                            that.userData.update('identity','secu',that.postulateData.secu);
                            that.userData.update('identity','last_visit',that.postulateData.last_visit);
                            that.userData.update('address','adr1',that.postulateData.adr1);
                            that.userData.update('address','adr2',that.postulateData.adr2);
                            that.userData.update('address','cp',that.postulateData.cp);
                            that.userData.update('address','ville',that.postulateData.ville);
                            that.userData.update('address','pays',that.postulateData.pays);
                            that.userData.update('documents','rib_info',that.postulateData.rib_info);
                            that.submitAttempt = false;
                            if(this.steps == 2) // no missions requirements
                            {
                                this.segment = "step3";
                                this.step = 3;
                            }
                            else
                            {
                                this.segment = "step2";
                                this.step = 2;
                            }
                        }
                    },
                    {
                        text: 'Annuler',
                        handler: data => {

                        }
                    }
                ]
            });
            prompt.present();
        }
        else
        {
            //console.log(this.postulateForm.value);
        }

    }
    contractConfirmation(){
        if(!this.cguAgreed)
        {
            this.cguError=true;
        }
        else {
            var that = this;
            let prompt = this.alertCtrl.create({
                title: 'Signature du contrat',
                message: that.uiData.getContractValidationWarning(),
                buttons: [
                    {
                        text: 'Je m\'engage',
                        handler: data => {
                            that.uploadSignatureTask = new Upload(null);
                            that.uploadSignatureTask.b64 = that.signature;

                            that.uploadSignatureTask.document_type = "signature";
                            that.uploadSignatureTask.specific_root = 'users/' + this.userData.token + '/missionContracts/' + that.mission.id;
                            that.userData.set('missionContracts/' + that.mission.id, {
                                'mission': that.mission,
                                'missionStatus': "scheduled",
                                'date': Date.now(),
                            });
                            that.uploadService.pushAsString("signature-" + that.mission.id + ".png", that.uploadSignatureTask).on(firebase.storage.TaskEvent.STATE_CHANGED,
                                (snapshot: any) => {
                                },
                                (error) => {
                                },
                                () => {
                                    that.userData.update('missionContracts/' + that.mission.id, "status", "signed");
                                    that.userData.update('missionCandidates/' + that.mission.id, "status", "signed");
                                    const toast = this.toastCtrl.create({
                                        message: 'Votre contrat de mission a été enregistré signé. Félicitation !',
                                        duration: 5000
                                    });
                                    this.dismiss(true);
                                    toast.present();
                                }
                            );
                            /**/
                        }
                    },
                    {
                        text: 'Annuler',
                        handler: data => {

                        }
                    }
                ]
            });
            prompt.present();
        }
    }
    canvasResize() {
        let canvas = document.querySelector('canvas');
        this
            .signaturePad
            .set('minWidth', 1);

        this
            .signaturePad
            .set('canvasWidth', canvas.offsetWidth);

        this
            .signaturePad
            .set('canvasHeight', canvas.offsetHeight);
    }


    ngAfterViewInit() {
        /*console.log("Reset Model Screen");
        this
            .signaturePad
            .clear();
        this.canvasResize();*/
    }


    drawComplete() {

        this.signatureImage = this
            .signaturePad
            .toDataURL();

    }

    drawClear() {
        this
            .signaturePad
            .clear();
    }

    dismiss(data?: any) {
        // using the injected ViewController this page
        // can "dismiss" itself and pass back data
        this.viewCtrl.dismiss(data);
    }

    openCGU()
    {
        window.open('https://www.novaterim.com/conditions-generales', '_system');
    }
}



// WEBPACK FOOTER //
// ./src/pages/missions/missions-sign/missions-sign.ts